import React from "react";

const Grabbed = () => {
  return (
    <svg width="15" height="13" viewBox="0 0 15 13" fill="none">
      <path
        d="M1.17425 6.49999L5 12.5H11.5C11.5 8 14.1743 8.99998 13.6743 3.49998C13.5 2.00001 11.5 2.00001 11.5 2.5C11.5 0.50003 8.5 0.500036 8.5 2.49998C8.5 0.5 5.5 0.50001 5.5 2.49998C4 1.00001 2.67419 2.00002 2.67425 2.99998V3.00007C2.67428 3.50004 2.67431 4.00011 3.67425 4.99998C1.17425 4.00006 0.674211 5.50006 1.17425 6.49999Z"
        fill="white"
      />
      <path
        d="M5.5 2.49998C4 1.00001 2.67419 2.00002 2.67425 2.99998C2.67428 3.49998 2.67425 4.00006 3.67425 4.99998C1.17425 4.00006 0.674211 5.50006 1.17425 6.49999L5 12.5H11.5C11.5 8 14.1743 8.99998 13.6743 3.49998C13.5 2.00001 11.5 2.00001 11.5 2.5M5.5 2.49998C5.5 0.50001 8.5 0.5 8.5 2.49998M5.5 2.49998V4.50001M8.5 2.49998C8.5 0.500036 11.5 0.50003 11.5 2.5M8.5 2.49998V4.50001M11.5 2.5V4.50001"
        stroke="black"
      />
    </svg>
  );
};

export default Grabbed;
